import { Dialog, DialogContent } from "@bleu.builders/ui";
import { LockClosedIcon } from "@radix-ui/react-icons";
import React from "react";
import { Link, useParams } from "react-router-dom";

import { useUser } from "#/contexts/UserContext";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";

function MustSubscribe() {
  const params = useParams();

  const billingPath = replaceParams(
    UserPagePath.ORGANIZATION_BILLING_SETTINGS,
    params,
  );

  return (
    <Dialog aria-labelledby="subscribe" open>
      <DialogContent
        onPointerDownOutside={(e) => e.preventDefault()}
        closeButton={<></>}
        aria-label="subscribe"
        className="sm:max-w-[550px] p-6 flex flex-col gap-4 bg-background dark:border-2 rounded-lg shadow-xl"
      >
        <div className="flex items-center gap-4">
          <LockClosedIcon className="size-6 text-foreground animate-spin-slow" />
          <h2 className="text-lg font-semibold text-foreground">
            Conteúdo Para Assinantes
          </h2>
        </div>
        <p className="text-foreground">
          Você precisa assinar para acessar este conteúdo. Assine agora para
          desbloquear o conteúdo exclusivo.
        </p>
        <Link
          className="bg-primary text-white ml-auto px-4 py-2 rounded-md font-bold transition-colors duration-300 ease-in-out hover:shadow-md hover:bg-primary/80"
          to={billingPath}
          replace
        >
          Assinar
        </Link>
      </DialogContent>
    </Dialog>
  );
}

export const withPaywall = (Component, predicate) => {
  return (props) => {
    const { user } = useUser();

    const hasPermission = predicate(user);

    if (!hasPermission) {
      return <MustSubscribe />;
    }

    return <Component {...props} />;
  };
};
